// extracted by mini-css-extract-plugin
export default {"footer":"footer---X6WYe","timestamp":"timestamp---sink2","leftContent":"leftContent---lOggB","rightContent":"rightContent---GOzEj"};